import { useEffect, useState } from "react";
import { database } from '../config/firebase';
import { onValue, ref, remove, getDatabase } from "firebase/database";
import rideService from "src/services/rideService";


export default function AllRiders() {
    const [rides, setRides] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [commission, setCommission] = useState([]);
    const [id, setId] = useState();
    useEffect(() => {
        setIsLoading(true);
        const query = ref(database, "bikeRideRequest");
        return onValue(query, (snapshot) => {
            const data = snapshot.val();

            if (snapshot.exists()) {
                const fetchedRides = Object.values(data);
                // Reverse to get latest first since Firebase returns in ascending order by default
                const ridesInReverseOrder = fetchedRides.reverse();

                setRides(ridesInReverseOrder);
            }
            setIsLoading(false);
        });

    }, []);
    const deleteProjectById = (uniqueId) => {
        const db = getDatabase();
        const projectRef = ref(db, `bikeRideRequest/${uniqueId}`); // Assuming 'projects' is your node

        remove(projectRef)
            .then(() => {
                window.location.reload();

            })
            .catch((error) => {

            });
    };
    useEffect(() => {
        rideService.allRideRatePerKmWithCommissionPercentage()
            .then((res) => {
                if (res.status == 200) {
                    setCommission(res.data);
                }
            })
    }, [])

    return (
        <>
            <div>

                <div className="w-9/12 mx-auto">
                    <div>
                        <div>
                            <h1 className="text-3xl font-bold my-5 text-purple-400 text-center">
                                Ride Request
                            </h1>
                        </div>

                        {isLoading ? (
                            <span className="loading loading-infinity loading-lg text-center"></span>
                        ) : (
                            <>
                                <div className="overflow-x-auto">
                                    <table className="table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>S.N</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Starting Point</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Destination</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Passenger Name</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Rider Name</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Rider Phone Number</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Price</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Vehicle Type</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Owner Commission</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Status</th>
                                                <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rides?.map((ride, index) => (
                                                <tr key={index}>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{index + 1}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.start_position}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.destination}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.full_name}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.rider_name}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.rider_phone_number}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.price}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.vehicle_type}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Rs:{ride.owner_commission ?? 0} </td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.status}</td>
                                                    <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>
                                                        <button
                                                            className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded mr-2"
                                                            onClick={() => deleteProjectById(ride.ride_request_id)}
                                                        >
                                                            Delete
                                                        </button>

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                    </div>
                </div>

            </div>

        </>
    );
}